import React, { useState } from "react";
import backgroundImage from "../assets/img/volunteerimage.png";
import backgroundImageheader from "../assets/img/volunteerheader.png";
import SEO from "./SEO";
import { useEffect } from "react";
import ReactGA  from "react-ga4";
const Volunteer = () => {
	// Add state for form data and validation
	const [formData, setFormData] = useState({
		fullName: "",
		email: "",
		phoneNumber: "",
		experience: "",
		availability: "",
		// consent: false,
	});
	const [errors, setErrors] = useState({});
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [submitMessage, setSubmitMessage] = useState("");

	// Validation functions
	const validateEmail = (email) => {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return emailRegex.test(email);
	};

	const validatePhoneNumber = (phoneNumber) => {
		const phoneNumberRegex = /^\+?[\d\s-]{10,}$/;
		return phoneNumberRegex.test(phoneNumber);
	};

	const validateForm = () => {
		const newErrors = {};

		// Full Name validation
		if (!formData.fullName.trim()) {
			newErrors.fullName = "Full name is required";
		} else if (formData.fullName.trim().length < 2) {
			newErrors.fullName = "Full name must be at least 2 characters long";
		}

		// Email validation
		if (!formData.email) {
			newErrors.email = "Email is required";
		} else if (!validateEmail(formData.email)) {
			newErrors.email = "Please enter a valid email";
		}

		// PhoneNumber validation
		if (!formData.phoneNumber) {
			newErrors.phoneNumber = "PhoneNumber number is required";
		} else if (!validatePhoneNumber(formData.phoneNumber)) {
			newErrors.phoneNumber = "Please enter a valid phoneNumber number";
		}

		// experience validation
		if (!formData.experience.trim()) {
			newErrors.experience = "Please describe your experience and experience";
		} else if (formData.experience.trim().length < 20) {
			newErrors.experience =
				"Please provide more details about your experience";
		}

		// Availability validation
		if (!formData.availability.trim()) {
			newErrors.availability = "Please specify your availability";
		}

		// Consent validation
		// if (!formData.consent) {
		// 	newErrors.consent = "You must agree to the volunteer guidelines";
		// }

		return newErrors;
	};

	// Handle input changes
	const handleInputChange = (e) => {
		const { name, value, type, checked } = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: type === "checkbox" ? checked : value,
		}));
		// Clear error when user types
		if (errors[name]) {
			setErrors((prev) => ({ ...prev, [name]: "" }));
		}
	};

	// Handle form submission
	const handleSubmit = async (e) => {
		e.preventDefault();

		// Validate form
		const newErrors = validateForm();
		if (Object.keys(newErrors).length > 0) {
			setErrors(newErrors);
			return;
		}

		setIsSubmitting(true);
		try {
			const response = await fetch(
				"https://office.synergycarefoundation.org/api/volunteer",
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(formData),
				}
			);

			if (response.ok) {
				setSubmitMessage(
					"Thank you for your application! We'll contact you soon."
				);
				setFormData({
					fullName: "",
					email: "",
					phoneNumber: "",
					experience: "",
					availability: "",
					// consent: false,
				});
			} else {
				setSubmitMessage("Something went wrong. Please try again.");
			}
		} catch (error) {
			console.error("Error submitting form:", error);
			setSubmitMessage("Failed to submit application. Please try again later.");
		} finally {
			setIsSubmitting(false);
		}
	};
useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/volunteer",
      title: "Volunteer | SynergyCare Foundation",
    });
  });
	return (
		<div className=''>
			<SEO
				title='Volunteer | SynergyCare Foundation'
				description=''
				name='SynergyCare Foundation'
				type=''
			/>
			<div
				style={{
					backgroundImage: `url(${backgroundImageheader})`,
				}}
				className='bg-cover bg-fixed bg-center bg-no-repeat'>
				<div className='text-center lg:pt-40 pt-24 pb-16 max-w-[1024px] mx-auto w-[90%] space-y-5'>
					<h1 className='text-white lg:text-[72px]/[79px] text-[40px]/[67px] lg:tracking-[-2px] tracking-[-1.72px] font-medium'>
						Volunteer with SynergyCare Foundation
					</h1>
					<p className='md:text-2xl/10 text-lg/6 text-[#ffffff]'>
						Our work is fueled by passionate volunteers like you. Whether you're
						guiding patients through the ref process, assisting in
						administrative tasks, or spreading awareness, your time and
						experience are essential to mission.
					</p>
				</div>
			</div>
			<div className='max-w-[1440px] w-[90%] mx-auto lg:py-20 py-10 space-y-8'>
				<h3 className='lg:text-[64px]/[80px] text-[32px]/[56px] font-medium lg:text-left text-center text-[#1D1D1D] md:tracking-[-3px] tracking-[-1.55px]'>
					Why Volunteer with Us
				</h3>
				<div className='flex gap-3  md:flex-row  flex-col justify-between '>
					<div className='flex flex-col gap-10 lg:w-[30%] w-full bg-[#45E99E] rounded-[30px] p-5'>
						<p className='w-[70%] text-[#025788] md:text-[32px]/[42px] text-[28px]/[38px] font-medium'>
							Make a Real Difference
						</p>
						<p className='text-[#025788] md:text-2xl/8 text-base/6'>
							Volunteering with us means directly impacting the lives of
							individuals in need, making healthcare more accessible to those
							who often face barriers.
						</p>
					</div>
					<div className='flex flex-col gap-10 lg:w-[30%] w-full bg-[#DFFBEE] rounded-[30px] p-5'>
						<p className='w-[90%] text-[#025788] md:text-[32px]/[42px] text-[28px]/[38px] font-medium'>
							Support a Meaningful Mission
						</p>
						<p className='text-[#025788] md:text-2xl/8 text-base/6'>
							Joining our team allows you to help communities in need gain
							access to healthcare, ensuring they receive the care they deserve
						</p>
					</div>
					<div className='flex flex-col gap-10 lg:w-[30%] w-full bg-[#FFEAC8] rounded-[30px] p-5'>
						<p className='w-[70%] text-[#025788] md:text-[32px]/[42px] text-[28px]/[38px] font-medium'>
							Flexible Roles
						</p>
						<p className='text-[#025788] md:text-2xl/8 text-base/6'>
							Volunteer positions are tailored to suit your availability and
							skill set.
						</p>
					</div>
				</div>
			</div>
			<div className='max-w-[1440px] w-[90%] mx-auto rounded-[20px]'>
				<div
					style={{
						backgroundImage: `url(${backgroundImage})`,
					}}
					className=' rounded-[20px] bg-cover bg-fixed bg-center bg-no-repeat'>
					<div className='bg-black/50 py-8 rounded-[20px]'>
						<div className='lg:w-[90%] w-[95%] mx-auto'>
							<h2 className='text-white lg:text-[64px]/[80px] text-[32px]/[56px] font-medium lg:text-left text-center md:tracking-[-3px] tracking-[-1.55px]'>
								Volunteer Roles
							</h2>
							<div className='flex gap-5 justify-center lg:flex-row  flex-col w-[100%] lg:pt-[180px] pt-10'>
								<div className='flex flex-col gap-10 lg:w-[30%] w-[100%]  bg-[#FFCF4E] rounded-[30px] p-5'>
									<h4 className='w-[50%] text-[#025788] md:text-[32px]/[42px] text-[28px]/[38px] font-medium'>
										Patient Support
									</h4>
									<p className='text-[#025788] md:text-2xl/8 text-base/6'>
										Assist patients in navigating the referral process, ensuring
										they connect with the right healthcare providers.
									</p>
								</div>
								<div className='flex flex-col gap-10 lg:w-[30%] w-[100%]   bg-transparent border-[3px]  rounded-[30px] p-5'>
									<h4 className='w-[90%] text-[#FFFFFF] md:text-[32px]/[42px] text-[28px]/[38px] font-medium text-wrap'>
										Administrative Support
									</h4>
									<p className='text-[#FFFFFF] md:text-2xl/8 text-base/6'>
										Help with tasks such as scheduling, data entry, and
										supporting the overall management of referrals.
									</p>
								</div>
								<div className='flex flex-col gap-10 lg:w-[30%] w-[100%]  bg-transparent border-[3px] rounded-[30px] p-5'>
									<h4 className='w-[70%] text-[#FFFFFF] md:text-[32px]/[42px] text-[28px]/[38px] font-medium'>
										Community Outreach
									</h4>
									<p className='text-[#FFFFFF] md:text-2xl/8 text-base/6'>
										Help us expand our reach, educating communities about the
										services we offer and assisting in patient enrolment.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<form
				onSubmit={handleSubmit}
				className='lg:py-20 py-10 max-w-[1440px] mx-auto w-[90%] space-y-10'>
				<h1 className='lg:text-[64px]/[80px] text-[32px]/[56px] font-medium  md:tracking-[-3px] tracking-[-1.55px] text-center text-[#1D1D1D]'>
					Volunteer Application Form
				</h1>
				<div className='max-w-[600px] mx-auto w-full space-y-10'>
					<h6 className=' text-[#1D1D1D] md:text-2xl/8 text-base/6 '>
						Personal Information
					</h6>
					<div className='relative'>
						<input
							name='fullName'
							value={formData.fullName}
							onChange={handleInputChange}
							placeholder='Full Name*'
							className={`w-full border-t-0 border-l-0 border-r-0 border-b-2 outline-none ${
								errors.fullName ? "border-red-500" : ""
							}`}
						/>
						{errors.fullName && (
							<p className='text-red-500 text-sm mt-1'>{errors.fullName}</p>
						)}
					</div>

					<div className='relative'>
						<input
							name='email'
							type='email'
							value={formData.email}
							onChange={handleInputChange}
							placeholder='Contact Email*'
							className={`w-full border-t-0 border-l-0 border-r-0 border-b-2 outline-none ${
								errors.email ? "border-red-500" : ""
							}`}
						/>
						{errors.email && (
							<p className='text-red-500 text-sm mt-1'>{errors.email}</p>
						)}
					</div>

					<div className='relative'>
						<input
							name='phoneNumber'
							value={formData.phoneNumber}
							onChange={handleInputChange}
							placeholder='Phone Number*'
							className={`w-full border-t-0 border-l-0 border-r-0 border-b-2 outline-none ${
								errors.phoneNumber ? "border-red-500" : ""
							}`}
						/>
						{errors.phoneNumber && (
							<p className='text-red-500 text-sm mt-1'>{errors.phoneNumber}</p>
						)}
					</div>
				</div>
				<div className='space-y-5 max-w-[600px] mx-auto w-full'>
					<h6 className='text-[#1D1D1D] md:text-2xl/8 text-base/6 '>
						Skills and Experience
					</h6>

					<textarea
						name='experience'
						value={formData.experience}
						onChange={handleInputChange}
						placeholder='Please provide details of any relevant experience or experience (e.g., healthcare, outreach, administration).'
						className={`w-full border-t-0 border-l-0 border-r-0 border-b-2 outline-none resize-none ${
							errors.experience ? "border-red-500" : ""
						}`}
						rows={2}
					/>
					{errors.experience && (
						<p className='text-red-500 text-sm mt-1'>{errors.experience}</p>
					)}
				</div>
				<div className='space-y-5 max-w-[600px] mx-auto w-full'>
					<h6 className=' text-[#1D1D1D] md:text-2xl/8 text-base/6'>
						How many hours per week can you commit to volunteering?
					</h6>
					<input
						name='availability'
						value={formData.availability}
						onChange={handleInputChange}
						placeholder='Availability'
						className={`w-full border-t-0 border-l-0 border-r-0 border-b-2 outline-none ${
							errors.availability ? "border-red-500" : ""
						}`}
					/>
					{errors.availability && (
						<p className='text-red-500 text-sm mt-1'>{errors.availability}</p>
					)}
				</div>
				<p className=' md:text-base/6 text-xs/5 text-black font-medium max-w-[600px] mx-auto w-full'>
					By submitting this form, I agree to volunteer in accordance with the{" "}
					<a
						href='/privacy-policy'
						className='text-[#45E99E] font-bold underline'>
						guidelines
					</a>{" "}
					of SynergyCare Foundation
				</p>
				{submitMessage && (
					<p
						className={`max-w-[600px] mx-auto w-full text-sm ${
							submitMessage.includes("error")
								? "text-red-500"
								: "text-green-500"
						}`}>
						{submitMessage}
					</p>
				)}
				<button
					type='submit'
					disabled={isSubmitting}
					className='text-[#000000] lg:text-lg/7 text-[12px]/5 py-2.5 lg:py-5 w-full max-w-[600px] mx-auto block  bg-[#45E99E] rounded-[67px] disabled:opacity-50 disabled:cursor-not-allowed'>
					{isSubmitting ? "Submitting..." : "Submit Application"}
				</button>
			</form>
		</div>
	);
};

export default Volunteer;
